import React from 'react'

import { CSSObject } from '@emotion/react'

import { useRecipe } from '../../model/context'
import { Text, FontFamily, FontWeight, Box } from '@gousto-internal/citrus-react'

export function Title({}: { styles?: CSSObject[] } = {}) {
  const recipe = useRecipe()

  return (
    <Box maxWidth={'80%'}>
      <Text size={3} fontFamily={FontFamily.Book} fontWeight={FontWeight.SemiBold}>
        {recipe.title}
      </Text>
    </Box>
  )
}
